import { useLocation } from 'react-router-dom'
import React, { useEffect } from 'react'
import './About_Us.css'

import banner from '../../assets/images/Abut us banner.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const About_Us = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0, 0);
  }, [top]);

  return (
    <>
      <div className="container-fluid gx-0">
        <div className="row gx-0">
          <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
        </div>
      </div>
      <div className="container pt-lg-5 pt-3">
        <div className="row py-lg-3">
          <div className="col-lg-6 col-md-6">
            <div className="card p-lg-5 p-3 about-us-top-card" data-aos="zoom-in">
              <h5>Mission Statement</h5>
              <p> At Oreus Lifesciences, our mission is to enhance the quality of life through affordable, innovative, and effective pharmaceutical solutions. We aim to bridge the gap between science and healthcare to ensure better patient outcomes.</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="card p-lg-5 p-3 about-us-top-card" data-aos="zoom-in">
              <h5>Vision</h5>
              <p>To be a global leader in pharmaceutical innovation, shaping the future of healthcare through research, compassion, and excellence.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="card p-lg-5 p-3 about-us-top-card about-us-top-card-3" data-aos="zoom-in">
              <h5>Leadership Team</h5>
              <p>Meet the dedicated team of scientists, healthcare professionals, and visionaries behind Oreus Lifesciences, driving our success with a shared passion for better health outcomes.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="card  p-lg-5 p-3 about-us-top-card" data-aos="zoom-in">
              <h5 >History & Milestones</h5>
              <p>Founded in 2023, Oreus Lifesciences has grown into a trusted name in the pharmaceutical industry, recognized for our cutting-edge research and commitment to patient care.
                Oreus has geographically expanded significantly in just one year of its launch and has widely gained acceptance across all channel partners. This has become possible, because of the par excellence quality products marketed by oreus, which has eventually helped oreus in gaining formidable acceptance across  patients, doctors and channel partners.
              </p>
            </div>
          </div>

        </div>
      </div>

      <div className='container'>

        <div className="row">
          <div className="col-lg-12">
            <div className='about-us-card' data-aos="zoom-in">
              <div className='about-content'>
                {/* <h1>Nimisha Gupta</h1> */}
                <h5>Director’s Message</h5>
                <p>Welcome to Oreus Lifesciences.</p>
                <p>At Oreus Lifesciences, our mission is to enhance health and quality of life by providing top-quality, ethically-produced pharmaceutical solutions. Every day, we are driven by a commitment to excellence, integrity, and customer satisfaction—values that guide each of our actions and define our relationship with those we serve.</p>
                <p>Our company stands on the principles of quality, trust, and a deep dedication to advancing healthcare. We take pride in developing quality-driven products across multiple therapeutic areas, aiming to make a meaningful impact on the lives of our patients and communities. Our team is composed of highly skilled professionals who share our passion for quality and innovation, ensuring that every product meets rigorous standards of safety and efficacy.</p>
                <p>At Oreus, we believe in more than just producing medicines; we believe in fostering connections with our customers and stakeholders. Our dedication to customer satisfaction and patient well-being is evident in every step we take—from research and development to the delivery of our products. By upholding strong ethical standards, we have earned the trust of our customers and built lasting partnerships within the healthcare community.</p>
                <p>As we look to the future, Oreus Lifesciences remains steadfast in our mission to lead with integrity and professionalism, continually striving to improve lives and set new benchmarks for quality in the pharmaceutical industry.</p>
                <p>Thank you for your continued trust and support in Oreus Lifesciences. We are honored to be a part of your healthcare journey.</p>
                <p>
                  Warm regards,<br />
                  Director<br />
                  Oreus Lifesciences
                </p>
                {/* <Link>Read More</Link> */}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row my-lg-5 d-flex justify-content-end">
        <div className="col-lg-10">
          <div className='about-us-card' data-aos="zoom-in">
          <div className='about-content'>
                  <h1>Atul Mishra</h1>
                  <h5>Director</h5>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aspernatur libero magnam iusto? Sint iusto nisi earum labore quia distinctio ipsam sed? Ipsum in modi vitae fugit. Aspernatur tempore iure, cumque iusto expedita non asperiores vel sit rerum aperiam ipsa reprehenderit architecto soluta consequuntur quaerat nulla. Nulla iusto vel nobis fugiat?</p>
                  <Link>Read More</Link>
                </div>
          </div>
        </div>
      </div> */}

        {/* <div className="row my-lg-5">
        <div className="col-lg-10">
          <div className='about-us-card' data-aos="zoom-in">
          <div className='about-content'>
                  <h1>Ashish Kumar</h1>
                  <h5>Director</h5>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat dolor deleniti voluptatem dolore accusantium fuga minima omnis, commodi, vitae alias laudantium voluptas nulla, voluptatum amet quas odit. Fugiat, ab. Consequatur sequi sit rem totam aliquam iste quia corrupti tempora, aspernatur officiis? Est aspernatur error quo magni iste quae ea facilis.</p>
                  <Link>Read More</Link>

                </div>
          </div>
        </div>
      </div> */}

      </div>

      <div className="container mb-lg-5 mb-3">
        <div className="row p-lg-5 p-md-4 p-3 leadership" data-aos="zoom-in">
          <div className="col-12">
            <h1 data-aos="zoom-in">Leadership Management</h1>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="director-card" data-aos="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#2e86c1" fill-opacity="1" d="M0,288L1440,64L1440,0L0,0Z"></path>
              </svg>
              <h5>Mrs. Nimisha Gupta</h5>
              <span>Director</span>

            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="director-card" data-aos="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#2e86c1" fill-opacity="1" d="M0,288L1440,64L1440,0L0,0Z"></path>
              </svg>
              <h5>Mr. Atul Mishra</h5>
              <span>Director</span>

            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="director-card" data-aos="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                <path fill="#2e86c1" fill-opacity="1" d="M0,288L1440,64L1440,0L0,0Z"></path>
              </svg>
              <h5>Mr. Ashish Kumar</h5>
              <span>Director</span>

            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default About_Us;
